/**
 * Test if sections contain given string slug value
 * @param {Array} sections
 * @param {String} keyword
 * @returns {Boolean}
 */
export const sectionContainSlug = (sections, keyword) => {
  if (!Array.isArray(sections)) {
    return false;
  }
  return sections.some((section) => (section && section.slug === keyword));
};

/**
 * Test if given value meets minimum requirement of being taxonomy term
 * @param {Object} term
 * @returns {Boolean}
 */
export const isTaxonomyTerm = (term) => !!term && typeof term === 'object' && typeof term.id === 'string';

/**
 * Pull ids from taxonomy term structure and returns a flat array
 * @param {Object} taxonomy
 * @returns {Array}
 */
export const extractTermIds = (taxonomy) => {
  // Return term id
  if (isTaxonomyTerm(taxonomy)) {
    return taxonomy.id;
  }
  let terms = [];
  if (typeof taxonomy === 'object') {
    // Object containing all taxonomy terms
    Object.values(taxonomy).forEach((row) => {
      // Is array of multiple terms
      if (Array.isArray(row) && row.length) {
        terms = [...terms, ...extractTermIds(row)];
      // Is single term
      } else if (isTaxonomyTerm(row)) {
        terms.push(row.id);
      }
    });
  }
  // Return uniques
  return terms.filter((value, index, self) => self.indexOf(value) === index);
};
